import { GreyGrey40, Box } from '@sequencehq/core-components'
import { ReactNode } from 'react'

export const Container: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      width="390px"
      height="291px"
      padding="16px"
      boxShadow="0 2px 4px 0 rgba(15, 23, 42, 0.08)"
      border={`1px solid ${GreyGrey40}`}
      borderRadius="lg"
      p={4}
    >
      {children}
    </Box>
  )
}
